<div class="d-flex flex-column h-100">

  <!-- Header -->
  <div class="panel-section-header px-3 pt-2 pb-2 flex-shrink-0">
    <div class="panel-eyebrow mat-font-label-sm text-uppercase fw-semibold mb-1">
      Custom Elements · Step 1 of 2
    </div>
      <div class="d-flex align-items-center gap-1 mb-1">
          <h2 class="mat-font-title-md fw-semibold mb-0">Set up detection</h2>
      </div>
    <p class="mat-font-body-sm mb-0 text-body-secondary">
      Detect custom objects in aerial imagery. Define a geographical area to start.
    </p>
  </div>

  <!-- Body -->
  <div class="overflow-y-auto flex-fill px-3 py-2 d-flex flex-column gap-2">

    <!-- Section: Draw on the map -->
    <div>
      <div class="mat-font-label-sm text-uppercase fw-semibold mb-2">
        Draw on the map
      </div>
      <div class="d-flex flex-column gap-1">
        @for (m of drawModes; track m.id) {
          <button class="area-mode-btn d-flex align-items-center gap-2 w-100 text-start p-2"
                  type="button"
                  [class.is-active]="selectedMode() === m.id"
                  [attr.aria-pressed]="selectedMode() === m.id"
                  [disabled]="!mapReady()"
                  (click)="selectDrawMode(m.id)">
            <span class="d-flex align-items-center justify-content-center flex-shrink-0">
              <mat-icon svgIcon="{{m.icon}}"></mat-icon>
            </span>
            <div class="flex-fill">
              <div class="mat-font-body-md fw-semibold">{{ m.label }}</div>
              <div class="mat-font-label-sm">
                {{ m.desc }}
              </div>
            </div>
            @if (selectedMode() === m.id) {
              <mat-icon class="flex-shrink-0 check-icon">check_circle</mat-icon>
            }
          </button>
        }
      </div>
    </div>

    <!-- Section: Or import a file -->
    <div>
      <div class="mat-font-label-sm text-uppercase fw-semibold mb-2">
        Or import a file
      </div>
      <button class="area-mode-btn area-mode-btn--import d-flex align-items-center gap-2 w-100 text-start p-2"
              type="button"
              [class.is-active]="isImportMode()"
              [attr.aria-pressed]="isImportMode()"
              (click)="openImportBoundaryDialog()">
        <span class="d-flex align-items-center justify-content-center flex-shrink-0">
          <mat-icon svgIcon="upload_file"></mat-icon>
        </span>
        <div class="flex-fill">
          <div class="mat-font-body-md fw-semibold">Import file</div>
          <div class="mat-font-label-sm">
            GeoJSON, KML, KMZ, Shapefile, WKT or CSV.
          </div>
        </div>
        @if (isImportMode()) {
          <mat-icon class="flex-shrink-0 check-icon">check_circle</mat-icon>
        }
      </button>
    </div>
  </div>

  <!-- Footer -->
  <div class="px-3 py-2 flex-shrink-0">
    <div class="d-flex gap-2">
      <button matButton class="flex-fill" type="button" (click)="clearArea()">
        Clear
      </button>
      <button matButton="filled" color="primary" class="flex-fill" type="button"
              [disabled]="!hasArea()"
              (click)="applyArea()">
          Apply Detection Area
      </button>
    </div>
  </div>

</div>
